require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-miracles-coop.json") })
        }
      }, "path---project-miracles-coop");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-miracles-coop!./.cache/json/project-miracles-coop.json
// module id = 350
// module chunks = 231608221292675